import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState('videos', ['videosAction']),
  },

  methods: {
    clearFilters() {
      this.$store.commit('videos/clearFilters')

      this.$store.dispatch(`videos/${this.videosAction}`, {
        slug: this.$route.params.slug,
      })
    },
  },
}
